import(/* webpackMode: "eager" */ "/vercel/path0/web/src/app/game/page.tsx")